export default __webpack_public_path__ + "adab4343012ddfd240fc53ef063f54f3.png";